export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-plus-exclusive.30b59b9a.svg","height":14,"width":244};